import { createApp } from 'vue'
import PrimeVue from 'primevue/config';

// External PrimeVue components in alphabetical order
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Column from 'primevue/column';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import DataTable from 'primevue/datatable'
import DataView from 'primevue/dataview'
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InlineMessage from 'primevue/inlinemessage';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Listbox from 'primevue/listbox';
import Message from 'primevue/message';
import Menu from 'primevue/menu';
import Password from 'primevue/password';
import ProgressSpinner from 'primevue/progressspinner';
import Ripple from 'primevue/ripple';
import ScrollPanel from 'primevue/scrollpanel';
import Sidebar from 'primevue/sidebar'
import SplitButton from 'primevue/splitbutton'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import TextArea from 'primevue/textarea';
import Timeline from 'primevue/timeline'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import ToggleButton from 'primevue/togglebutton'
import Tooltip from 'primevue/tooltip';

// Non PrimeVue components
import Multiselect from '@vueform/multiselect'
import Popper from "vue3-popper";

// CSS 
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import '@vueform/multiselect/themes/default.css';
import './styles/layout.scss';

// Local typescript components
import router from '@/router/router'
import store from '@/store/store'

// Local vue components
import App from '@/App.vue'
import PropertyCustomerDetails from '@/views/PropertyCustomerDetails.vue'
import BillingEntities from '@/views/BillingEntities.vue'
import BwofTemplate from '@/views/DocumentTemplates/BwofTemplate.vue'
import CertificateOfComplianceTemplate from '@/views/DocumentTemplates/CertificateOfComplianceTemplate.vue'
import CertificateOfComplianceTemplateExternal from '@/views/DocumentTemplates/CertificateOfComplianceTemplateExternal.vue'
import ComplianceTemplate from '@/views/DocumentTemplates/ComplianceTemplate.vue'
import CompanySummaryPanel from '@/views/CompanySummaryPanel.vue'
import CompanyList from '@/views/CompanyList.vue'
import Contacts from '@/views/Contacts.vue'
import ContractorIQPStatementTemplate from '@/views/DocumentTemplates/ContractorIQPStatementTemplate.vue'
import DocumentGeneration from '@/views/DocumentGeneration.vue'
import DocumentList from '@/views/DocumentList.vue'
import EmailTemplate from '@/views/EmailTemplate.vue'
import EvacuationReport from '@/views/DocumentTemplates/EvacuationReport.vue'
import InspectionTemplate from '@/views/DocumentTemplates/InspectionTemplate.vue'
import Login from '@/components/Login.vue';
import LoginSkin from '@/components/LoginSkin.vue';
import OutboundEmailList from '@/views/OutboundEmailList.vue';
import PropertyBwof from '@/views/PropertyBwof.vue'
import PropertyDashboard from '@/views/PropertyDashboard.vue'
import PropertyEvacuation from '@/views/PropertyEvacuation.vue'
import PropertyServiceTable from '@/views/PropertyServiceTable.vue'
import ReportInLieuOfForm12ATemplate from '@/views/DocumentTemplates/ReportInLieuOfForm12ATemplate.vue'
import ServiceDefinitions from '@/views/ServiceDefinitions.vue'
import ContactDetailsPopup from './views/ContactDetailsPopup.vue';
import SignatureModal from './views/SignatureModal.vue';

// Application instance
const app = createApp(App)


	.use(router)
	.use(store)
	.use(ConfirmationService)
	.use(PrimeVue)
	.use(ToastService)

	// With prime, we only import components we will actually use
	.component('Badge', Badge)
	.component('Button', Button)
	.component('Calendar', Calendar)
	.component('Card', Card)
	.component('Chart', Chart)
	.component('Checkbox', Checkbox)
	.component('Column', Column)
	.component('ConfirmDialog', ConfirmDialog)
	.component('DataTable', DataTable)
	.component('DataView', DataView)
	.component('Dialog', Dialog)
	.component('Dropdown', Dropdown)
	.component('FileUpload', FileUpload)
	.component('InlineMessage', InlineMessage)
	.component('InputText', InputText)
	.component('InputSwitch', InputSwitch)
	.component('InputNumber', InputNumber)
	.component('Listbox', Listbox)
	.component('Menu', Menu)
	.component('Message', Message)
	.component('Password', Password)
	.component('ProgressSpinner', ProgressSpinner)
	.component('ScrollPanel', ScrollPanel)
	.component('Sidebar', Sidebar)
	.component('SplitButton', SplitButton)
	.component('TabPanel', TabPanel)
	.component('TabView', TabView)
	.component('TextArea', TextArea)
	.component('Timeline', Timeline)
	.component('Toast', Toast)
	.component('ToggleButton', ToggleButton)

	// Non PrimeVue components
	.component("Popper", Popper)
	.component('Multiselect', Multiselect)

	// Local components
	.component('PropertyCustomerDetails', PropertyCustomerDetails)
	.component('BillingEntities', BillingEntities)
	.component('BwofTemplate', BwofTemplate)
	.component('CertificateOfComplianceTemplate', CertificateOfComplianceTemplate)
	.component('CertificateOfComplianceTemplateExternal', CertificateOfComplianceTemplateExternal)
	.component('ComplianceTemplate', ComplianceTemplate)
	.component('CompanySummaryPanel', CompanySummaryPanel)
	.component('CompanyList', CompanyList)
	.component('Contacts', Contacts)
	.component('ContractorIQPStatementTemplate', ContractorIQPStatementTemplate)
	.component('DocumentGeneration', DocumentGeneration)
	.component('DocumentList', DocumentList)
	.component('EmailTemplate', EmailTemplate)
	.component('EvacuationReport', EvacuationReport)
	.component('InspectionTemplate', InspectionTemplate)
	.component('Login', Login)
	.component('LoginSkin', LoginSkin)
	.component('OutboundEmailList', OutboundEmailList)
	.component('ContactDetailsPopup', ContactDetailsPopup)
	.component('SignatureModal', SignatureModal)
	.component('PropertyBwof', PropertyBwof)
	.component('PropertyDashboard', PropertyDashboard)
	.component('PropertyEvacuation', PropertyEvacuation)
	.component('PropertyServiceTable', PropertyServiceTable)
	.component('ReportInLieuOfForm12ATemplate', ReportInLieuOfForm12ATemplate)
	.component('ServiceDefinitions', ServiceDefinitions)

// Directives
app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);

// Add a generic unhandled exception handler
app.config.errorHandler = (err, vm, _) => {
	console.error(err);

	if (vm && vm.$toast) {
		vm.$toast.add({
			severity: 'error',
			summary: 'Unexpected exception',
			detail: err ? err as string: undefined
		});
		return;
	}

	// todo: should use Sentry.
	alert(err);
}

app.mount('#app');
